<template>
    <Modal :show="vShow" :title="title" @onClose="handleModalClose">
        <template v-slot:content>
            <div class="title-wrap d-flex justify-content-between mb-3">
                <div class="title-text font-weight-bold">Profile</div>
                <!-- <b-link class="text-primary text-underline font-weight-bold">Edit</b-link> -->
            </div>
            <div class="profile-item mb-4">
                <div class="profile-item-label text-secondary mb-2">Email</div>
                <div class="profile-item-text text-dark">{{ $auth.user.email }}</div>
            </div>
            <div class="title-wrap d-flex justify-content-between mb-3">
                <div class="title-text font-weight-bold">Membership</div>
                <b-link class="text-primary text-underline font-weight-bold" :disabled="disabled.upgrade"
                    @click="handleUpgrade"><b-spinner :hidden="!loading.upgrade" small></b-spinner>Upgrade</b-link>
            </div>
            <div class="membership-wrap">
                <b-badge pill variant="info" class="py-3 px-4 membership-wrap-badge">{{ $auth.user.isPro ? 'Pro Member' :
                    'Free Member' }}</b-badge>
                <b-link v-if="$auth.user.isPro" class="text-danger text-underline font-weight-bold ml-2"
                    @click="beforeCancelMembership"><b-spinner :hidden="!loading.cancel" class="mr-1"
                        small></b-spinner>Cancel Membership</b-link>
            </div>
            <div class="border-top my-3"></div>
            <div class="text-center">
                <b-button pill variant="outline-danger" size="lg" class="px-4" @click="handleLogout"><b-spinner
                        :hidden="true" small></b-spinner><i class="bi bi-box-arrow-right mr-2"></i>Logout</b-button>
            </div>
            <Modal :show="showCancelTip" type="error" title="Attention: Subscription Cancellation Notice" okText="Continue"
                content="Please be informed that your subscription will be cancelled effective from the next billing cycle. However, you will still be able to access and use the service until the end of the current billing cycle."
                :footer="true" @onClose="handleCancelTipClose" @onOk="handleCancelMembership">
            </Modal>
        </template>
    </Modal>
</template>
  
<script>
import Modal from '@/components/modal/Modal'
import { getUserCheckoutAPI, cancelSubscriptionAPI } from '@/api/user'
import * as amplitude from '@amplitude/analytics-browser';

export default {
    name: 'Account',
    components: {
        Modal,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            vShow: false,
            title: 'My Account',
            loading: {
                upgrade: false,
                cancel: false,
            },
            disabled: {
                upgrade: true
            },
            showCancelTip: false
        }
    },
    computed: {
        userId() {
            return this.$auth.user.sub && this.$auth.user.sub.replace('auth0|', 'auth0_') || ''
        }
    },
    watch: {
        show: {
            handler(newVal, oldVal) {
                this.vShow = newVal
            }
        }
    },
    mounted() { },
    methods: {
        // 关闭事件
        handleModalClose() {
            this.$emit("onClose");
        },
        // 用户登出
        handleLogout() {
            this.$auth.logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            });
        },
        // 订阅升级
        handleUpgrade() {
            if (this.loading.upgrade) return

            // 埋点
            amplitude.track('User pay')

            this.loading.upgrade = true

            let params = {
                userId: this.userId,
            }

            getUserCheckoutAPI(params).then(url => {
                window.location.href = url
            }).catch(error => {
                this.$error(error.response.data.error)

                this.loading.upgrade = false
            })
        },
        // 取消订阅提示
        beforeCancelMembership() {
            if (this.loading.cancel) return

            this.showCancelTip = true
        },
        // 关闭取消订阅提示
        handleCancelTipClose() {
            this.showCancelTip = false
        },
        // 取消订阅逻辑
        handleCancelMembership() {
            this.showCancelTip = false
            this.loading.cancel = true

            let params = {
                userId: this.userId,
            }

            cancelSubscriptionAPI(params).then(url => {
                this.$emit("onClose");
                this.$emit("onCancelMembership");

                this.loading.cancel = false
            }).catch(error => {
                this.$error(error.response.data.error)

                this.loading.cancel = false
            })
        },
    }
}
</script>
  
<style scoped lang="scss">
.membership-wrap {
    &-badge {
        color: #6E9EAF;
        background-color: #CEEFFB;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account.vue